import { render, staticRenderFns } from "./IbxDuplicate.vue?vue&type=template&id=7bf5ed38"
import script from "./IbxDuplicate.vue?vue&type=script&lang=js"
export * from "./IbxDuplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports